import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { LoginPageComponent } from './login-page/login-page.component';
//need to do auth guards for these routes
import { PocPageComponent } from './poc-page/poc-page.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { authRedirectGuard } from './guards/auth-redirect.guard';
import { OffshoreReportingComponent } from './offshore-reporting/offshore-reporting.component';
import { OffshoreNewReportComponent } from './offshore-reporting/offshore-new-report/offshore-new-report.component';
import { ViewOffshoreReportsPageComponent } from './offshore-reporting/view-offshore-reports-page/view-offshore-reports-page.component';

export const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [authRedirectGuard],
    children: [{ path: 'login', component: LoginPageComponent }],
  },
  {
    path: 'site',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    data: { layout: 'main' },
    children: [
      {
        path: ':vesselId',
        children: [
          {
            path: 'crew-dashboard',
            loadChildren: () =>
              import('@navstation-portal/reporting/feature/crew-dashboard-shell').then(
                (m) => m.crewDashboardRoutes,
              ),
          },
          {
            path: 'vessel-reports',
            loadChildren: () =>
              import('@navstation-portal/reporting/feature/vessel-reporting-shell').then(
                (m) => m.vesselReportingRoutes,
              ),
          },
          {
            path: 'offshore-reports',
            children: [
              {
                path: 'view-reports',
                component: ViewOffshoreReportsPageComponent,
              },
              {
                path: 'new-report',
                component: OffshoreReportingComponent,
              },
              {
                path: ':reportId',
                component: OffshoreReportingComponent,
              },
            ],
          },
          {
            path: 'engine-reports',
            loadChildren: () =>
              import('@navstation-portal/reporting/feature/engine-reports-shell').then(
                (m) => m.engineReportsRoutes,
              ),
          },
          {
            path: 'vessel-settings',
            loadChildren: () =>
              import('@navstation-portal/reporting/feature/vessel-settings-shell').then(
                (m) => m.vesselSettingsRoutes,
              ),
          },
          {
            path: 'client-settings',
            loadChildren: () =>
              import('@navstation-portal/reporting/feature/client-settings-shell').then(
                (m) => m.clientSettingsRoutes,
              ),
          },
          {
            path: 'user-settings',
            loadChildren: () =>
              import('@navstation-portal/reporting/feature/user-settings-shell').then(
                (m) => m.userSettingsRoutes,
              ),
          },
          {
            path: 'fuel-tanks',
            loadChildren: () =>
              import('@navstation-portal/fuel-tanks/feature/fuel-tanks-shell').then(
                (m) => m.fuelTanksRoutes,
              ),
          },
          {
            path: 'management',
            loadChildren: () =>
              import('@navstation-portal/reporting/feature/management-shell').then(
                (m) => m.managementRoutes,
              ),
          },
        ],
      },
    ],
  },
  { path: 'poc', component: PocPageComponent },
  { path: '**', redirectTo: '' },
];
